import { render, staticRenderFns } from "./staffManagement.vue?vue&type=template&id=487753c3&scoped=true&"
import script from "./staffManagement.vue?vue&type=script&lang=js&"
export * from "./staffManagement.vue?vue&type=script&lang=js&"
import style0 from "./staffManagement.vue?vue&type=style&index=0&id=487753c3&lang=less&scoped=true&"
import style1 from "./staffManagement.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487753c3",
  null
  
)

component.options.__file = "staffManagement.vue"
export default component.exports